@if (isExpired$ | async) {
  <div
    class="sw-expired-backdrop"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="sw-expired-title"
    aria-describedby="sw-expired-desc"
  >
    <div class="sw-expired-box">

      <!-- Ícono de bloqueo -->
      <div class="sw-expired-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" stroke-width="1.8" fill="none"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
          <circle cx="12" cy="16" r="1.2" fill="currentColor"/>
        </svg>
      </div>

      <!-- Badge -->
      <span class="sw-expired-badge">Plan vencido</span>

      <!-- Título -->
      <h2 class="sw-expired-title" id="sw-expired-title">
        Tu acceso ha sido suspendido
      </h2>

      <!-- Mensaje -->
      <p class="sw-expired-message" id="sw-expired-desc">
        Tu plan <strong>Gratis</strong> ha vencido. Para continuar usando ShareWave,
        actualiza tu plan. Si tienes preguntas, contáctate con tu asesor.
      </p>

      <!-- Acciones -->
      <div class="sw-expired-actions">
        <button class="sw-btn-upgrade" (click)="upgrade()" type="button">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
               stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
            <polyline points="17 6 23 6 23 12"/>
          </svg>
          Mejorar mi plan
        </button>
        <button class="sw-btn-logout" (click)="logout()" type="button">
          Cerrar sesión
        </button>
      </div>

    </div>
  </div>
}
